import { render, staticRenderFns } from "./performance-scoring-sc-summary.vue?vue&type=template&id=4489bcbf"
import script from "./performance-scoring-sc-summary.vue?vue&type=script&lang=js"
export * from "./performance-scoring-sc-summary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports